import styled from 'styled-components';
import MEDIA from 'helpers/mediaTemplates';

import iconClear from './icons/clear.svg';
import iconArrow from './icons/arrow.svg';

export const StyledRoot = styled.span`
  display: flex;
  align-items: center;
  margin: 24px 0;

  white-space: nowrap;
  font-size: 18px;
  line-height: 24px;

  ${MEDIA.TABLET`
    margi: 0 24px;
    font-size: 44px;
    line-height: 32px;
  `}
`;

export const StyledGap = styled.span`
  flex-grow: 1;
`;

export const StyledFilter = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  ${MEDIA.TABLET`
    margin: 28px 0;
  `}

  & + & {
    margin-left: 16px;
  }
`;

export const StyledSelect = styled.select`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  ${MEDIA.TABLET`font-size: 24px`}

  display: inline-block;
  opacity: 0;
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  opacity: .6;

  ${({ selected }) => selected && `
    color: #000;
    opacity: 1;
  `}

  height: 100%;
`;

export const StyledArrow = styled.div`
  display: inline-block;
  height: 32px;
  width: 32px;

  background: url(${iconArrow}) no-repeat center;
  background-position-y: 12px;
  background-size: 50%;

  ${MEDIA.TABLET`
    background-position-y: 16px;
    background-size: 70%;
    height: 40px;
    width: 40px;
  `}
`;

export const StyledClear = styled.div`
  display: flex;
  outline: none;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    opacity: .4;
    pointer-events: none;
  `}
`;

export const StyledClearText = styled.span`
  display: none;
  margin: 0 20px;

  ${MEDIA.TABLET_XL`
    display: inline-block;
  `}
`;

export const StyledClearIcon = styled.div`
  heigh: 32px;
  width: 32px;
  background: url(${iconClear}) no-repeat center;
  background-size: 50%;

  ${MEDIA.PHONE`
    height: 40px;
    width: 40px;
  `}
`;
